const particlesShader = {
  vertex: 
  `  
    uniform sampler2D uFBOTexture;
    uniform float uSize;
    uniform vec3 uCameraPosition;
    uniform float uFogStart;
    uniform float uFogLenght;
    
    attribute vec2 aFboUv;
    attribute float aSize;

    varying  float vFog;
    
    void main()
    {
      vec4 fboColor = texture2D(uFBOTexture, aFboUv);

      vec4 modelPosition = modelMatrix * vec4(fboColor.xyz, 1.0);
      
      // For from camera distance
      vFog = distance(uCameraPosition.z, modelPosition.z);
      vFog -= uFogStart;
      vFog = uFogLenght - vFog;
      vFog = vFog / uFogLenght;

      vec4 viewPosition = viewMatrix * modelPosition;
      gl_Position = projectionMatrix * viewPosition;
  
      float lifeSize = min((1.0 - fboColor.a) * 10.0, fboColor.a * 2.0);
      lifeSize = clamp(lifeSize, 0.0, 1.0);
  
      gl_PointSize = uSize * lifeSize * aSize;
      gl_PointSize *= (1.0 / - viewPosition.z);
    }
  `,
  fragment: 
  `
    uniform vec3 uColor;
    varying  float vFog;
    
    void main()
    {
      gl_FragColor = vec4(uColor, vFog);
    }
  `
}

export default particlesShader